import i18n from '@/utils/i18n'
import PageAll from '@/components/PageAll'
const languages = i18n.messages[i18n.locale].router
  
export default [
    {
        path: '/message',
        name: 'message',
		subheader: languages.message.title,
        meta: {
            requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
            permCode: "03",
            icon: "message",
        },
        component: PageAll,
		children: [
			{
				path: '/message',
				name: 'message',
				component: resolve => require(['@/pages/message/index'], resolve),
				meta: {
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					title: languages.message.title1,
					permCode: "0301",
				},
			}
		]
    },
]
  